import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import searchIcon from "../assets/icons/search_icon.png";
import CreateSupportTicket from "../components/modals/CreateSupportTicket";
import small_plus_icon from "../assets/icons/small_plus_icon.png";

const Support = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [accordion1, setAccordion1] = useState(false);
  const [createSupportModal, setCreateSupportModal] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Help & Support" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="text-[18px] ml-4 mt-8">Help & Support</div>
      <div className="ml-4 mt-6 rounded-lg bg-[#F4F9FF] p-4 w-[80%] flex flex-col items-center">
        <p className="text-[12px] font-bold ">FAQs</p>
        <p className="text-[16px] mt-4">
          Have any questions? We're here to assist you.
        </p>
        <div className="flex bg-[#FFFFFF] px-4 rounded-xl w-full justify-center mt-10">
          <img src={searchIcon} className="object-cover w-6 p-1" alt="search" />
          <input
            placeholder="Search here"
            className="bg-[#FFFFFF] w-full text-[12px]"
          />
        </div>
      </div>

      <div className="ml-4 mt-10">
        <div
          className="w-[80%] shadow-lg p-4 rounded-lg cursor-pointer"
          onClick={() => setAccordion1(!accordion1)}
        >
          <div className="flex justify-between items-center ">
            <p className="text-[14px]">
              How does it benefit post-exhibition experiences?
            </p>
            {!accordion1 ? (
              <img
                src={small_plus_icon}
                alt="add"
                className="border border-[#2F80ED] rounded-md"
              />
            ) : null}
            {accordion1 ? (
              <p className="bg-[#2F80ED] text-white w-5 h-5 rounded-md flex justify-center items-center cursor-pointer">
                -
              </p>
            ) : null}
          </div>

          {accordion1 ? (
            <div className="mt-4">
              <p className="text-[12px] text-[#6F6C90]">
                It allows you to track leads generated during exhibitions,
                manage tasks related to follow-ups, and analyze social media
                interactions with potential clients.
              </p>
            </div>
          ) : null}
        </div>

        <div className="w-[80%] shadow-lg p-4 rounded-lg cursor-pointer mt-6">
          <div className="flex justify-between items-center ">
            <p className="text-[14px]">How can I add leads to the CRM app?</p>

            <img
              src={small_plus_icon}
              alt="add"
              className="border border-[#2F80ED] rounded-md"
            />
          </div>
        </div>
        <div className="w-[80%] shadow-lg p-4 rounded-lg cursor-pointer mt-6">
          <div className="flex justify-between items-center ">
            <p className="text-[14px]">
              How does the CRM app help analyze post-exhibition performance?
            </p>

            <img
              src={small_plus_icon}
              alt="add"
              className="border border-[#2F80ED] rounded-md"
            />
          </div>
        </div>
        <div className="w-[80%] shadow-lg p-4 rounded-lg cursor-pointer mt-6">
          <div className="flex justify-between items-center ">
            <p className="text-[14px]">
              What types of tasks can I manage in the app for post exhibition
              follow ups?
            </p>

            <img
              src={small_plus_icon}
              alt="add"
              className="border border-[#2F80ED] rounded-md"
            />
          </div>
        </div>
      </div>

      <div
        className="border border-[#2F80ED] p-2 w-[80%] rounded-lg my-8 ml-4 flex justify-center cursor-pointer"
        onClick={() => setCreateSupportModal(true)}
      >
        <button className="text-[#2F80ED]">Create Support Ticket</button>
      </div>

      {createSupportModal ? (
        <CreateSupportTicket setCreateSupportModal={setCreateSupportModal} />
      ) : null}
    </div>
  );
};

export default Support;
